import { Div } from '../../../../base/components/native/div'

export const Inspiration = () => {

    const images = [
        '/images/insp-1.jpeg',
        '/images/insp-2.jpeg',
        '/images/insp-3.jpeg',
        '/images/insp-4.jpeg',
        '/images/insp-5.jpeg',
        '/images/insp-6.jpeg',
        '/images/insp-7.jpeg',
        '/images/insp-8.jpeg',
        '/images/insp-9.jpeg',
        '/images/insp-10.jpeg',
        '/images/insp-11.jpeg',
        '/images/insp-12.jpeg',
        '/images/insp-13.jpeg',
        '/images/insp-14.jpeg',
        '/images/insp-15.jpeg',
    ]


    const base = Div()
    const title = Div('Inspiration')
    const desc = Div('Famous art created by our loyal community')
    const container = Div()
    images.forEach((image, i) => {
        const img = Div()
        img.cssClass({
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '325px',
            height: '325px',
            borderRadius: '10px',
            margin: '5px',
            transform: i%2 === 0 ? 'translateX(-50%)': ''
        })
        container.append(img)
    })

    base.append(title, desc, container)
    title.cssClass({
        fontFamily: 'Syne',
        fontSize: '36px',
        fontWeight: '700',
        marginBottom: '30px',
    })
    desc.cssClass({
        padding: '0 30px',
        marginBottom: '40px',
    })
    container.cssClass({
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        height: '675px',
        width: '100%',
        margin: '0 auto',
        overflowY: 'hidden',
        overflowX: 'scroll'
    })
    base.cssClass({
        marginTop: '0',
        paddingTop: '120px',
        paddingBottom: '60px',
        backgroundColor: '#000',
        width: '100%',
        textAlign: 'center',
        color: '#fff',
        '@media (max-width: 768px)': {
            // marginTop: '40px',
        }
    })

    return base
}